import { apiGet, apiPost } from '../services/apiClient';

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.set(k, v);
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

export const listReviews = (token, params = {}) => apiGet(`/api/admin/reviews${buildQuery(params)}`, token);
export const getReview = (token, id) => apiGet(`/api/admin/reviews/${id}`, token);
export const hideReview = (token, id, payload = {}) => apiPost(`/api/admin/reviews/${id}/hide`, payload, token);
export const publishReview = (token, id, payload = {}) => apiPost(`/api/admin/reviews/${id}/publish`, payload, token);
export const removeReview = (token, id, payload = {}) => apiPost(`/api/admin/reviews/${id}/remove`, payload, token);
export const addNote = (token, id, payload = {}) => apiPost(`/api/admin/reviews/${id}/note`, payload, token);
